import { SpotifyQueueSchema, type SpotifyQueue } from '@mixwire/contracts';

import { queueStreamUrl } from '../api/spotify.js';

import { useSpotifyStream } from './useSpotifyStream.js';

export const useQueue = (): SpotifyQueue | undefined =>
  useSpotifyStream(queueStreamUrl, SpotifyQueueSchema);
